class ReportField {
    $type: string = "irng.ReportField, irng.Data";

    isOriginalTemplate: boolean;

    private _id: string;

    id: KnockoutComputed<string> = ko.pureComputed({
        read: function (this: ReportField) {
            if (!this._id) {

            }
            return this._id;
        },
        write: function (this: ReportField, value: string) {
            this._id = value;
        },
        owner: this
    });

    field: number;
    private _fieldObject: FieldNameInputModel;
    private get fieldObject() {
        if (!this._fieldObject) {
            this._fieldObject = MappingService.getField(this.field);
        }
        return this._fieldObject;
    }

    autoGrouping: KnockoutObservable<AutoGroupingEnum> = ko.observable(AutoGroupingEnum.None);
    groupingType: KnockoutObservable<GroupingTypeEnum> = ko.observable(GroupingTypeEnum.NONE);
    isReportMetric: boolean;
    visible: KnockoutObservable<boolean> = ko.observable(true);
    color: KnockoutObservable<string> = ko.observable(null);
    titleAlign: KnockoutObservable<TextAlignEnum> = ko.observable(TextAlignEnum.Auto);
    valuesAlign: KnockoutObservable<TextAlignEnum> = ko.observable(TextAlignEnum.Auto);
    orderIndex: KnockoutObservable<number> = ko.observable(null);
    order: KnockoutObservable<Order> = ko.observable(Order.ASC);
    groupId: KnockoutObservable<number> = ko.observable(0);
    width: KnockoutObservable<number> = ko.observable(null);

    
    //Property that the user edits
    protected _customDisplayName: KnockoutObservable<string> = ko.observable();
    customDisplayName: KnockoutComputed<string> = ko.pureComputed({
        read: function (this: ReportField) {
            return this._customDisplayName();
        },
        write: function (this: ReportField, value: string) {
            if (this.field && this.fieldDisplayName === value) {
                this._customDisplayName(null);
                this._displayName = null;
            }
            else {
                this._customDisplayName(value);
            }
        },
        owner: this
    });
    //get customDisplayName() {
    //    return this._customDisplayName;
    //}
    //set customDisplayName(value: string) {
    //    if (this.field && this.fieldDisplayName === value) {
    //        this._customDisplayName = null;
    //        this._displayName = null;
    //    }
    //    else {
    //        this._customDisplayName = value;
    //    }
    //}

    //Used to display on reports
    protected _displayName: string;
    displayName: KnockoutComputed<string> = ko.pureComputed({
        read: function (this: ReportField) {
            return this._displayName ?? (this.customDisplayName() ?? this.fieldDisplayName);
        },
        write: function (this: ReportField, value: string) {
            if (this.field && this._displayName === this.fieldDisplayName)
                this._displayName = null;
            else
                this._displayName = value;
        },
        owner: this
    });
    //get displayName() {
    //    return this._displayName ?? (this.customDisplayName() ?? this.fieldDisplayName);
    //}
    //set displayName(value: string) {
    //    if (this.field && this.displayName === this.fieldDisplayName)
    //        this._displayName = null;
    //    else
    //        this._displayName = value;
    //}

    _partitionBy: KnockoutObservable<boolean> = ko.observable(null);
    partitionBy: KnockoutComputed<boolean> = ko.pureComputed({
        read: function (this: ReportField) {
            if (this instanceof MetricField) {
                return null;
            }

            return this._partitionBy() ?? this.fieldType === DataTypeEnum.DATE;
        },
        write: function (this: ReportField, value: boolean) {
            this._partitionBy(value);
        },
        owner: this
    });

    //Used for Chart
    index: number;

    //label: string;
    //serieName: string;
    ////from Field class
    //tableName: string;
    ////property is renamed in JsonProperty attribute
    //get table(): string {
    //    return this.tableName;
    //}
    //set table(value: string) {
    //    this.tableName = value;
    //}
    //fieldName: string;
    //restrictBy: boolean;
    //type: any;

    get isMetric() {
        return false;
    }

    get isAutoGroupField() {
        return this.autoGrouping() != AutoGroupingEnum.None;
    }

    //get displayNameForDesigner() {
    //    return this.displayName ?? (this.field ? this.fieldDisplayName : null);
    //}
    displayNameForDesigner: KnockoutComputed<string> = ko.pureComputed({
        read: function (this: ReportField) {
            return this.customDisplayName() ?? (this.displayName() + (this.isAutoGroupField ? " " + autoGroupingToStringAndSplit(this.autoGrouping()) : ""));
            //return this.displayName() ?? (this.field ? this.fieldDisplayName : null);
        },
        write: function (this: ReportField, value: string) {
            this.customDisplayName(value);
        },
        owner: this
    });

    get queryName() {
        return `${this.fieldQueryName}_${groupingTypeToString(this.groupingType())}${(this.autoGrouping() != AutoGroupingEnum.None ? "_" + autoGroupingToString(this.autoGrouping()) : "")}`;
    }

    get dataType() {
        return this.isMetric ? DataTypeEnum.NUMBER : this.fieldType;
    }

    get fieldOriginalName(): string {
        return this.fieldObject.originalName;
    }
    get fieldDisplayName(): string {
        let displayName = null;
        if (this.isOriginalTemplate) {
            displayName = this.fieldObject.originalName;
        }

        return displayName ?? this.fieldObject.displayName;
        //return this.fieldObject.displayName;
    }
    get fieldDisplayTableName(): string {
        return this.fieldObject.tableName;
    }
    get fieldType(): DataTypeEnum {
        return this.fieldObject.type;
    }
    get fieldQueryName() {
        return `F${this.field}`;
    }

    _designerVM: ReportFieldDesignerVM;
    get designerVM() {
        if (!this._designerVM) {
            this._designerVM = new ReportFieldDesignerVM();
        }
        return this._designerVM;
    }

    constructor(data?: any, isOriginalTemplate: boolean = false) {
        if (!data) {
            return;
        }
        //Start with empty, but it will be updated later again
        //this.serieName = "";

        //if (data.$type) {
        //    this.$type = data.$type;
        //}
        this.isOriginalTemplate = isOriginalTemplate;
        this.id(data.id);
        this.field = data.field;
        this.autoGrouping(data.autoGrouping);
        this.groupingType(data.groupingType);
        this.isReportMetric = data.isReportMetric ?? false;
        this.visible(data.visible);
        this.color(data.color);
        this.titleAlign(data.titleAlign);
        this.valuesAlign(data.valuesAlign);
        this.orderIndex(data.orderIndex);
        this.order(data.order);
        this.groupId(data.groupId === -1 ? 0 : data.groupId ?? 0);
        this.width(data.width);

        this._displayName = isOriginalTemplate ? null : data.displayName;
        this._customDisplayName(data.customDisplayName);
        this._partitionBy(data.partitionBy);
    }

    static createReportOrMetricField(data: any, isOriginalTemplate: boolean = false) {
        if (data?.metricContainer) {
            return new MetricField(data, isOriginalTemplate);
        }
        else {
            return new ReportField(data, isOriginalTemplate);
        }
    }
}